export default class ElementsBuilder {
    constructor(runbook, level) {
        this.runbookId = runbook.id
        this.runbook = runbook

        this.nodes = {}
        this.deviceNodes = {}
        this.edges = []
        this.accDeviceNodes = {}
        this.level = level
    }

    getStatusCount(accNode) {
        let statusCount = {}
        Object.values(accNode.data.deviceNodes).forEach((node) => {
            const status = node.data.status
            if (status === undefined || status === null) {
                return
            }
            if (!statusCount[status]) {
                statusCount[status] = 0
            }
            statusCount[status]++
        })

        return statusCount
    }

    getElements() {
        this.getNodes()
        this.getEdges()

        for (const [, accNode] of Object.entries(this.accDeviceNodes)) {
            const { parentId } = accNode.data

            this.nodes[parentId].data = {
                ...this.nodes[parentId].data,
                type: 'devices',
                count: Object.keys(accNode.data.deviceNodes).length,
                statusCount: this.getStatusCount(accNode),
                deviceNodes: accNode.data.deviceNodes,
            }
        }

        return { nodes: Object.values(this.nodes), edges: this.edges }
    }

    getNodes() {
        const { actions } = this.runbook
        actions.uids.forEach((uid) => {
            const action = this.getAction(uid)
            // if (this.isDeviceNode(action)) {
            //     this.addDeviceNode(uid, action.name, {status: action.status});
            // }
            // else {
            this.level.forEach((level) => {
                if (actions.byId[uid].depth === level) {
                    this.addNode(
                        uid,
                        action.name,
                        { status: action.status, type: 'solution' },
                        { x: action.positionX, y: action.positionY }
                    )
                }
            })
            // }
        })
    }

    getEdges() {
        const { actions } = this.runbook

        actions.uids.forEach((uid) => {
            const action = this.getAction(uid)

            if (uid in this.nodes) {
                if (action.nextSibling && action.nextSibling in this.nodes) {
                    const nextAction = this.getAction(action.nextSibling)
                    if (!this.hasParents(nextAction)) {
                        this.addEdge(uid, action.nextSibling)
                    }
                }
                if (this.hasChildren(action)) {
                    action.children.forEach((childUid) => {
                        const child = this.getAction(childUid)
                        if (!this.hasParents(child) && childUid in this.nodes) {
                            this.addEdge(uid, childUid)
                        }
                    })
                }

                if (this.hasParents(action)) {
                    action.parents.forEach((parentUid) => {
                        if (parentUid in this.nodes) {
                            this.addEdge(parentUid, uid)
                        }
                    })
                }
            }
        })
    }

    // Added a new parameter for the position so the data does not receive unnecessary information
    addNode(id, name, data, position) {
        if (position.x !== null && position.y !== null) {
            this.nodes[id] = {
                data: {
                    id: `${id}`,
                    name: name,
                    ...data,
                },
                position: { x: position.x, y: position.y },
            }
        } else {
            this.nodes[id] = {
                data: {
                    id: `${id}`,
                    name: name,
                    ...data,
                },
            }
        }
    }

    addDeviceNode(id, name, data) {
        this.deviceNodes[id] = {
            data: {
                id: `${id}`,
                name: name,
                ...data,
            },
        }
    }

    addAccDeviceNode(parentId, id, name, data) {
        const accNodeId = `acc${parentId}`
        if (!this.accDeviceNodes[accNodeId]) {
            this.accDeviceNodes[accNodeId] = {
                data: {
                    id: accNodeId,
                    parentId,
                    name: 'Devices',
                    deviceNodes: {},
                },
            }
        }

        this.accDeviceNodes[accNodeId].data.deviceNodes[id] = {
            data: {
                id: `${id}`,
                name: name,
                ...data,
            },
        }
    }

    addEdge(source, target, details = null) {
        const deviceNode = this.deviceNodes[target]
        if (deviceNode) {
            this.addAccDeviceNode(
                source,
                target,
                deviceNode.data.name,
                deviceNode.data
            )
        } else {
            this.edges.push({
                data: { source: `${source}`, target: `${target}`, ...details },
            })
        }
    }

    getAction(uid) {
        const { actions } = this.runbook
        return actions.byId[uid]
    }

    hasChildren(action) {
        return action.children && action.children.length > 0
    }

    hasParents(action) {
        return action.parents && action.parents.length > 0
    }

    isDeviceNode(action) {
        return (
            action.deviceClass !== 'DR Solution' &&
            action.deviceClass !== 'Business Solution' &&
            action.deviceClass !== ''
        )
    }
}
